/**
 * 开平仓--被称作委托动作
 */
export enum OrderActionEnum {
    OPEN = 1,
    CLOSE = 2
}

/**
 * 子账户划转操作
 */
export enum TransferActionEnum {
    ADD = 1,
    REDUCE = 0
}

/**
 * 普通委托、计划委托--被称作委托类型
 *
 */
export enum OrderTypeEnum {
    NORMAL = 0,
    PLAN = 1,
    TRACK = 2,
    SCALED = 3,
    ICEBERG = 4,
}

/**
 * 限价委托、闪电委托--被称作价格类型
 */
export enum OrderPriceTypeEnum {
    LIMIT = 0,
    MARKET = 1,
    BBO_LIMIT = 2 //新增bbo 限价下单类型
}

/**
 * 市价触发、合理标记价格触发--被称作计划委托触发类型
 */
export enum OrderTriggerTypeEnum {
    MARKET = 1,
    FAIR = 2
}

/**
 * 买入、卖出--被称为交易方向
 */
export enum OrderTradeDirectionEnum {
    Buy = 'buyer',
    Sell = 'seller'
}

/**
 * 下单方式：快速下单；下单面板下单
 */

export enum OrderTradeWay {
    QUICK_ORDER = 'quickOrder',
    ORDER_PANEL = 'orderPanel'
}

/**
 * 合约止盈止损拉杆最大值（百分比）
 */
export const MAX_STOP_PERCENT = Number.MAX_VALUE

/**
 * 跟单-合约 止盈止损拉杆最大值（百分比）
 */
export const MAX_STOP_PERCENT_FOR_COPY_TRADING = 200
